import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../components/Header";
import { AppBar, Box, Tab } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import Patientinfo from "../components/Patientinfo";
import LeftNav from "../components/LeftNav";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { apiAxios, cndWrapperURL, sdkWrapperURL } from "../Util/ApiAxios";
import Loader from "react-loader-spinner";
import axios from "axios";

const CreateAppointments = () => {
  const classes = useStyles();
  const [isLoading, setLoading] = React.useState(false);
  const [patDetails, setPatDetails] = React.useState({});
  const [infoCND, setInfoCND] = React.useState({ token: "", id: "" });

  const pd_id = JSON.parse(localStorage.getItem("dhct_patient")).pd_id;

  useEffect(() => {
    let Token = localStorage.getItem("dhct_Token");
    (async () => {
      setLoading(true);
      try {
        const infoResp = await apiAxios.post(
          "/patient/get-doctor-nurse-info",
          { pd_id },
          { headers: { Authorization: Token } }
        );
        if (infoResp.data.statusCode !== 200)
          throw new Error("Failed to get doctor info.");
        setPatDetails({
          doctor: {
            id: infoResp.data.doctor.id,
            name: `${infoResp.data.doctor.first_name} ${infoResp.data.doctor.last_name}`,
          },
          nurse: {
            id: infoResp.data.nurse.id,
            name: `${infoResp.data.nurse.first_name} ${infoResp.data.nurse.last_name}`,
          },
        });
        const tokenResp = await axios.post(
          sdkWrapperURL("/auth/refresh-token"),
          { platform_name: "DHCT", response_platform_name: "CARENOWDOC" },
          { headers: { Authorization: Token } }
        );
        if (tokenResp.data.statusCode !== 200)
          throw new Error("Failed to refresh token.");
        setInfoCND({ token: tokenResp.data.token, id: tokenResp.data.id });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [pd_id]);

  return (
    <div>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      <Header />
      <Box className={classes.Pagecontent}>
        <Box className={classes.Leftcol}>
          <Box className={classes.leftnav}>
            <Patientinfo />
            <Box className={classes.TabPatientinfo}>
              <LeftNav />
            </Box>
          </Box>
        </Box>
        <Box className={classes.Rightcol}>
          {isLoading ? (
            <Loader
              type="ThreeDots"
              color="#114ebd"
              height={75}
              width={75}
              timeout={0}
              className={classes.loader}
            />
          ) : (
            <>
              {/* <h3>Book Appointments</h3> */}
              <div className={classes.container}>
                <h3>Nurse:&nbsp;{patDetails?.nurse?.name}</h3>
                <h3>Doctor:&nbsp;{patDetails?.doctor?.name}</h3>
              </div>
              <iframe
                src={cndWrapperURL(
                  `/clinic/redirect?${new URLSearchParams({
                    id: infoCND.id,
                    token: infoCND.token,
                    patient_id: pd_id,
                    doctor_id: patDetails?.nurse?.id,
                  }).toString()}`
                )}
                sandbox="allow-same-origin allow-scripts allow-forms"
                title="Create Appointments"
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  overflow: "hidden",
                  minHeight: "100vh",
                }}
                allowFullScreen
              />
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default CreateAppointments;
const useStyles = makeStyles(() => ({
  Pagecontent: {
    width: "100%",
    display: "flex",
    textAlign: "left",
  },
  TabPatientinfo: {
    "@media only screen and (max-width: 820px)": {
      display: "none",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  Leftcol: {
    width: "22%",
    background: "linear-gradient(45deg, #114ebd, #0f3d6e)",
    padding: "20px 3%",
    position: "relative",
    minHeight: "1050px",
    "@media only screen and (max-width: 1200px)": {
      width: "24%",
      padding: "20px 1%",
    },
    "@media only screen and (max-width: 820px)": {
      position: "absolute",
      background: "none",
      width: "98%",
      padding: "20px 1%",
      minHeight: 35,
    },
    "@media only screen and (max-width: 768px)": {
      position: "absolute",
      background: "none",
      width: "98%",
      padding: "20px 1%",
      minHeight: 35,
    },
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  Rightcol: {
    width: "78%",
    padding: "20px 3%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 1200px)": {
      width: "72%",
      padding: "0 1%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 60,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 60,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minHeight: "40px",
    },
  },
  contacttab: {
    background: "#fff",
    boxShadow: "none",
    color: "#000",
    textTransform: "capitalize",
    "& .MuiTabs-indicator": {
      display: "none !important",
    },
    "& .MuiTabs-flexContainer": {
      borderRadius: "10px",
      background: "#F3F3F3",
      width: "360px",
      textTransform: "capitalize",
      overflow: "hidden",
      "& .MuiTab-textColorInherit.Mui-selected": {
        background: "#0f3d6e",
        color: "#ffffff",
      },
      "& .MuiTab-textColorInherit": {
        textTransform: "capitalize",
        fontSize: "16px",
        padding: "0 22px",
      },
      "& .MuiTabPanel-root": {
        padding: "24px 0",
      },
    },
  },
  loader: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
  },
}));
